import React from 'react';

import { Link } from 'react-router-dom';
import './productCard.css';

const ProductCard = ({ item }) => {
    return (
        <div>

            <Link to={`/productDetails/${item.id}`}>
                <div className='product-item'>
                    <div className="image-box">
                        <img
                            src={require(`../../assets/product-img/${item.image}`)}
                            alt={item.name}
                            className='image'
                        />
                    </div>

                    <div className='product-name'>{item.name}</div>

                    <button className='more-btn'>
                        More Details
                    </button>
                </div>

            </Link>

        </div>
    );
}

export default ProductCard;
